import type {
  PersistReducerConfig,
  PersistStoreConfig,
  ReducerTransform,
} from '../types';

import createFilter from 'redux-persist-transform-filter';

import { persist as persistAccount } from './account';
// import { persist as persistCart } from './cart';
// import { persist as persistSearch } from './search';
// import { persist as persistTracking } from './tracking';

export default function persist(): PersistStoreConfig {
  return {
    // make sure you indicate which reducers you would like to persist here
    whitelist: ['account' /*'tracking', 'search', 'cart'*/],
    transforms: [
      createTransform(persistAccount),
      // createTransform(persistCart),
      // createTransform(persistSearch),
      // createTransform(persistTracking),
    ],
  };
}

function createTransform(config: PersistReducerConfig): ReducerTransform {
  return createFilter(config.reducer, config.whitelist);
}
